/**
 * A ficha do Grupo de Empresas (13.9, FR-88).
 *
 *     /grupos/$grupoId    as filiais e a soma dos Negócios, Orçamentos e Pedidos delas
 *
 * Página, como a ficha da Empresa (`rotas/empresa.tsx`), e não modal. **`CAMINHOS` não muda**: o
 * Grupo não é item de navegação — ele é alcançado pelo cartão Grupo da ficha da Empresa. O
 * `key={grupoId}` remonta a ficha ao trocar de Grupo: o rascunho do nome e da inclusão não atravessa.
 */

import { Link, createRoute } from '@tanstack/react-router'

import { FichaDoGrupo } from '@/modulos/cadastro/FichaDoGrupo'
import { useGrupo } from '@/modulos/cadastro/api'
import { useDefinirSubtitulo, useDefinirTitulo } from '@/shell/Shell'
import { CAMINHOS } from '@/shell/navegacao'
import { rotaDaAplicacao } from './aplicacao'

/** O caminho da ficha do Grupo. Escrito uma vez; quem precisa dele o importa. */
export const CAMINHO_DO_GRUPO = '/grupos/$grupoId'

function TelaDoGrupo() {
  const { grupoId } = rotaDoGrupo.useParams()
  const grupo = useGrupo(grupoId)
  useDefinirTitulo(grupo.data?.nome ?? 'Grupo')
  useDefinirSubtitulo('Grupo de empresas')
  return (
    <div className="ficha-do-grupo">
      <p className="grupo__voltar">
        <Link to={CAMINHOS.empresas}>← Voltar a Empresas</Link>
      </p>
      <FichaDoGrupo key={grupoId} grupoId={grupoId} />
    </div>
  )
}

export const rotaDoGrupo = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: CAMINHO_DO_GRUPO,
  component: TelaDoGrupo,
})
